export default __webpack_public_path__ + "static/media/vector-left.ecca8be9.png";